import React from "react";
import { useState, useEffect } from "react";
import {useDispatch, useSelector } from "react-redux";
import {
    getVideogames,
    getAllGenres,
    } from "../../actions"
import Card from "../Card/Card"
import Paginado from "../Paginado/Paginado";
import NavBar from "../NavBar/NavBar";
import "./Home.css";
import fondoHome from "../assets/ornn.png";
export default function Home(){
    const dispatch = useDispatch();

    const allVideogames2 = useSelector((state) => state.videogames);
    const allGenres = useSelector((state) => state.genres);
    const [orden, setOrden] =useState('');


    const [currentPage, setcurrentPage] = useState(1);
    const [videoGamesPerPage] = useState(15);
    const indexOfLast = currentPage * videoGamesPerPage;
    const indexOffirst = indexOfLast - videoGamesPerPage;
    const currentVideogames = allVideogames2.slice(indexOffirst,indexOfLast);
    const paginado = (pageNumber) => {
        setcurrentPage(pageNumber);
      };


    useEffect(()=>{
        dispatch(getVideogames());
        dispatch(getAllGenres());
    },[dispatch])
    

    //un refresh por si se bugea la pagina
    function handleClick(event){
        event.preventDefault();
        dispatch(getVideogames());
    }


    return(
        <div className="container-main">
            <div>
            
            </div>
            <div>
                <img className="imgFondoHome" src={fondoHome} alt="not found" />
            </div>

            <div className="NavBar">
            <NavBar
            setcurrentPage={setcurrentPage}
            setOrden={setOrden}
            allGenres={allGenres}
            orden={orden}
            handleClick={handleClick}
            />
            </div>

            <div className="paginadoTop">
            <Paginado
                videoGamesPerPage={videoGamesPerPage}
                allVideogames={allVideogames2.length}
                paginado={paginado}
                setcurrentPage={setcurrentPage}
            />
            </div>    
     
            <div className="cardGames">
            {currentVideogames?.map((ele) =>{
            return (
                <div key={ele.id} className="cardHom">
                <Card 
                    id={ele.id}
                    className="Card2"
                    platforms={ele.platforms}
                    key={ele.id}
                    name={ele.name}
                    background_image={ele.background_image}
                    genres={ele.genres}
                    rating={ele.rating}
                    screenshots={ele.screenshot}
                />
                </div>
            )    
            })}
            </div>
            <div className="containerPaginadoBottom">
            <Paginado
                videoGamesPerPage={videoGamesPerPage}
                allVideogames={allVideogames2.length}
                paginado={paginado}
            />
            </div>

            <div className="footer">
                <p className="text">Copyright &copy;</p>
            </div>
        </div>
    )
}